import { customFetch } from '#/services/customFetch'
import type { FAQ } from '../types/faq.types'

export async function getFaqs(): Promise<FAQ[]> {
  return customFetch<FAQ[]>('/student/faqs')
}
